import { render, staticRenderFns } from "./TravelMap.vue?vue&type=template&id=97033ae8&scoped=true"
import script from "./TravelMap.vue?vue&type=script&lang=js"
export * from "./TravelMap.vue?vue&type=script&lang=js"
import style0 from "./TravelMap.vue?vue&type=style&index=0&id=97033ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97033ae8",
  null
  
)

export default component.exports